// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"df1b4eac","839":"07371063"}[chunkId] + ".chunk.js";
};